function Footer () {
    return (
        <div className="w-full text-white md:text-lg text-sm font-medium font-myriad text-center shrink-0">
            &copy;2023 All rights reserved | Autumn Design Studio
        </div>
    );
}

export default Footer;